package app.components

import app.api.ProjectStepApi
import app.api.ProjectStepApi.StepUpdate
import app.model.ContainerDefinition
import dev.fritz2.core.*

fun RenderContext.containerDefinitionsInput(
    stepIndex: Int,
    containerDefinitions: List<ContainerDefinition>,
    projectStepApi: ProjectStepApi
) {
    p("text-sm") { +"Container Definitions:" }
    div("border rounded w-64 border-black p-2 flex flex-col divide-y divide-black gap-2") {
        containerDefinitions.forEachIndexed { j, containerDefinition ->
            div {
                projectStepInputText(
                    label = "Container Name:",
                    value = containerDefinition.containerName,
                    onChange = {
                        projectStepApi.updateStep(
                            Pair(
                                stepIndex, StepUpdate.ContainerDefinition(
                                    j,
                                    containerDefinition.copy(containerName = it)
                                )
                            )
                        )
                    }
                )
                projectStepInputText(
                    label = "Deployable Name:",
                    value = containerDefinition.deployableName,
                    onChange = {
                        projectStepApi.updateStep(
                            Pair(
                                stepIndex, StepUpdate.ContainerDefinition(
                                    j,
                                    containerDefinition.copy(deployableName = it)
                                )
                            )
                        )
                    }
                )
            }
        }
        div("flex justify-center p-2") {
            div("inline-flex rounded-full bg-blue-500 p-1") {
                div("h-6 w-6 text-center cursor-pointer text-white") {
                    +"+"
                    clicks handledBy {
                        projectStepApi.updateStep(
                            Pair(
                                stepIndex,
                                StepUpdate.AddContainer
                            )
                        )
                    }
                }
                div("h-6 w-6 text-center cursor-pointer text-white") {
                    +"-"
                    clicks handledBy {
                        projectStepApi.updateStep(
                            Pair(
                                stepIndex,
                                StepUpdate.RemoveContainer
                            )
                        )
                    }
                }
            }
        }
    }
}
